import { DETAILS, ISSUE_TEMPLATES, STEP_TEMPLATES } from "../constants";

export const ASSIGNMENT_TEMPLATE_TABS_LIST = [
  {
    name: DETAILS,
    value: DETAILS,
    label: DETAILS,
  },
  {
    name: STEP_TEMPLATES,
    value: STEP_TEMPLATES,
    label: STEP_TEMPLATES,
  },
  {
    name: ISSUE_TEMPLATES,
    value: ISSUE_TEMPLATES,
    label: ISSUE_TEMPLATES,
  },
];

export const ASSIGNMENT_TEMPLATE_TABS = {
  DETAILS,
  STEP_TEMPLATES,
  ISSUE_TEMPLATES,
};
